<div class="paginator d-flex flex-wrap align-items-center justify-content-between gap-2 pt-3">
  <span class="paginator-range">
    {{
      'backoffice.common.paginator.range'
        | translate
          : {
              first: firstRow(),
              last: lastRow(),
              total: total(),
              page: humanPage(),
              pages: pageCount(),
            }
    }}
  </span>

  <div class="d-flex align-items-center gap-2">
    <label class="paginator-size d-flex align-items-center gap-2" for="page-size">
      {{ 'backoffice.common.paginator.rows' | translate }}
      <select
        id="page-size"
        class="page-size-select px-2 py-1"
        [value]="pageSize()"
        [disabled]="disabled()"
        (change)="changeSize($any($event.target).value)"
      >
        @for (size of sizeOptions; track size) {
          <option [value]="size">{{ size }}</option>
        }
      </select>
    </label>

    <button
      type="button"
      class="page-btn d-flex align-items-center justify-content-center"
      [matTooltip]="'backoffice.common.paginator.previous' | translate"
      [attr.aria-label]="'backoffice.common.paginator.previous' | translate"
      [disabled]="!canGoBack()"
      (click)="previous()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button
      type="button"
      class="page-btn d-flex align-items-center justify-content-center"
      [matTooltip]="'backoffice.common.paginator.next' | translate"
      [attr.aria-label]="'backoffice.common.paginator.next' | translate"
      [disabled]="!canGoForward()"
      (click)="next()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
